var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"navbar navbar-dark sticky-top flex-md-nowrap child",attrs:{"id":"header"}},[_c('a',{staticClass:"navbar-brand col-md-3 col-lg-2 me-0",attrs:{"id":"logo-link","href":"/"}},[_c('img',{attrs:{"id":"logo-1","src":"/themes/web/assets/images/logo.png","alt":""}})])])
}]

export { render, staticRenderFns }